import { render, staticRenderFns } from "./absents.vue?vue&type=template&id=183934de&"
import script from "./absents.vue?vue&type=script&lang=js&"
export * from "./absents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports